
define('text!modules/companion/templates/select_item.html',[],function () { return '{{#typeOptions}}\n<option value="{{value}}"{{#selected}} selected{{/selected}}>{{text}}</option>\n{{/typeOptions}}';});

